import { render, staticRenderFns } from "./Installer.vue?vue&type=template&id=cf58282e&"
import script from "./Installer.vue?vue&type=script&lang=js&"
export * from "./Installer.vue?vue&type=script&lang=js&"
import style0 from "./Installer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports